module.exports = __webpack_public_path__ + "media/智能--社区WIFI.4f0afab5.mp4";